// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { LinkedButton } from '@/components/linked-button';
import { NavigateNextRounded } from '@/constants/hardfin-standard-icons';
import { useTriageCustomerCounts } from '@/customer/hooks/use-triage-customer-counts';
import { useTriageItemCounts } from '@/items/hooks/use-triage-counts';
import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

/**
 * Card component displaying triage item counts and a link to review them.
 * Shows the count of synced and pending SKUs from NetSuite integration.
 */
export function ClassifyIntegrationDataCard() {
  const { needsReview: itemNeedsReview, matched: itemMatched } =
    useTriageItemCounts();
  const { needsReview: customerNeedsReview, matched: customerMatched } =
    useTriageCustomerCounts();

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Box
        padding={2}
        bgcolor="grey.50"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="overline" marginRight="auto">
            Classify new integration data
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Review data synced from your integrations and manage matching
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Qty. synced</TableCell>
            <TableCell>Qty. pending</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant="body2">SKUs</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{itemMatched}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{itemNeedsReview}</Typography>
            </TableCell>
            <TableCell align="right">
              <LinkedButton
                to="/integrations/triage/items"
                size="small"
                variant="text"
                endIcon={<NavigateNextRounded fontSize="small" />}
              >
                Review
              </LinkedButton>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="body2">Customers</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{customerMatched}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{customerNeedsReview}</Typography>
            </TableCell>
            <TableCell align="right">
              <LinkedButton
                to="/integrations/triage/customers"
                size="small"
                variant="text"
                endIcon={<NavigateNextRounded fontSize="small" />}
              >
                Review
              </LinkedButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}
